var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagazine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 47,
    viewBox: "0 0 45 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5846 39.2287V10.2444C44.5846 9.73192 44.3731 9.2406 43.9968 8.87804C43.6201 8.5158 43.1096 8.31228 42.5771 8.31228H34.5466V2.51551C34.5466 2.00299 34.3352 1.51132 33.9588 1.14911C33.5821 0.786536 33.0717 0.583008 32.5392 0.583008H30.5318C27.8693 0.583008 25.3161 1.60099 23.4336 3.41286C21.5512 5.22472 20.4939 7.68217 20.4939 10.2444V10.293C18.7662 9.01454 16.6498 8.31866 14.4709 8.31228H2.42542C1.89293 8.31228 1.38247 8.5158 1.00578 8.87804C0.629428 9.24061 0.417969 9.7319 0.417969 10.2444V39.2287C0.417969 39.7412 0.629428 40.2329 1.00578 40.5951C1.38248 40.9573 1.89291 41.1612 2.42542 41.1612H14.4709C15.8013 41.1673 17.0917 41.5972 18.1413 42.3837C19.1908 43.1702 19.9404 44.269 20.273 45.5088C20.3839 45.9232 20.6353 46.2905 20.9868 46.553C21.3383 46.8151 21.7703 46.958 22.2153 46.958H22.7873C23.2323 46.958 23.6643 46.8151 24.0158 46.553C24.3673 46.2905 24.6187 45.9232 24.7296 45.5088C25.0622 44.2691 25.8118 43.1703 26.8613 42.3837C27.9109 41.5973 29.2013 41.1673 30.5317 41.1612H42.5772C43.1097 41.1612 43.6201 40.9573 43.9968 40.5951C44.3732 40.2329 44.5846 39.7413 44.5846 39.2287ZM24.5088 10.2444C24.5088 8.70724 25.1435 7.23266 26.2729 6.14558C27.4024 5.05824 28.9343 4.44759 30.5319 4.44759V29.5673C28.3529 29.5737 26.2366 30.2699 24.5089 31.548L24.5088 10.2444ZM14.4709 37.2964H4.43302V12.1767H14.4709C16.0684 12.1767 17.6004 12.7873 18.7298 13.8744C19.8593 14.9617 20.494 16.4359 20.494 17.9736V39.2624C18.7638 37.9907 16.6482 37.2999 14.471 37.2962L14.4709 37.2964ZM40.5695 37.2964H30.5315C28.3543 37.2995 26.2384 37.9902 24.5085 39.2626V39.2286C24.5085 37.6914 25.1432 36.2168 26.2727 35.1297C27.4021 34.0424 28.9341 33.4317 30.5316 33.4317H32.539C33.0715 33.4317 33.582 33.2282 33.9587 32.8656C34.335 32.5034 34.5465 32.0118 34.5465 31.4996V12.1767H40.5695V37.2964Z",
    fill: "url(#paint0_linear_1458_3354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1458_3354",
    x1: 0.417969,
    y1: 46.958,
    x2: 44.5846,
    y2: 46.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazine);
export default __webpack_public_path__ + "static/media/magazine.6920b9f077041911b38e75562220a815.svg";
export { ForwardRef as ReactComponent };